import { Grid } from '@fs/zion-ui'
import React from 'react'
import LifeSketchCardSkeleton from '../cards/life-sketch-card/LifeSketchCardSkeleton'
import OtherInformationCardSkeleton from '../cards/other-information-card/OtherInformationCardSkeleton'
import OtherRelationshipsCardSkeleton from '../cards/other-relationships-card/OtherRelationshipsCardSkeleton'
import useSourceCentricDetailsFlag from '../../data-service/useSourceCentricDetailsFlag'

export default function NonVitalsTabSkeleton(): JSX.Element {
  const isSourceCentric = useSourceCentricDetailsFlag().data?.isOn
  return (
    <Grid gutters={isSourceCentric ? 'sm' : 'nano'}>
      {!isSourceCentric && <OtherInformationCardSkeleton />}
      <OtherRelationshipsCardSkeleton />
      {isSourceCentric && <OtherInformationCardSkeleton />}
      {!isSourceCentric && <LifeSketchCardSkeleton />}
    </Grid>
  )
}
